import { useEffect } from 'react';

function useOutsideClick(wrapper, buttonRef, onClickOutside, isOpen) {
  function handleClickOutside(event) {
    if (isOutside(wrapper, event) && isOutside(buttonRef, event)) {
      onClickOutside();
    }
  }

  const isOutside = (node, event) => {
    return node.current && !node.current.contains(event.target) ? true : false;
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  });
}

export default useOutsideClick;
